import { observer } from "mobx-react";
import { InternalValuationReviewStore } from "../stores/internalValuationReviewStore";
import { PropertyCompFormStore } from "../stores/propertyCompFormStore";
import { UploadImageButton } from "./uploadImageButton";

interface UploadPropertyImageButtonProps {
  internalValuationReviewStore: InternalValuationReviewStore;
  propertyCompFormStore: PropertyCompFormStore;
}

//Only shown for the comparables that came without a photo, the upload is saved right away.
export const UploadPropertyImageButton = observer(({ internalValuationReviewStore, propertyCompFormStore }: UploadPropertyImageButtonProps) => {
  const propertyCompId = propertyCompFormStore.form.fields.propertyCompId.value;

  return (
    <UploadImageButton
      internalValuationReviewStore={internalValuationReviewStore}
      testId={`uploadPropertyImage-${propertyCompId}`}
      onUpload={file => internalValuationReviewStore.uploadPropertyCompImage(propertyCompFormStore, file) as unknown as Promise<any>}
    />
  );
});
